import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { ICalendarTemplateActivityPanel } from "ICalendarTemplate/activity/ICalendarTemplateActivityPanel";
import { ICalendarTemplateDetailSection } from "ICalendarTemplate/ICalendarTemplateDetailSection";
import ICalendarTemplateOptionsPanel from "ICalendarTemplate/ICalendarTemplateOptionsPanel";
import { useLoaderData } from "react-router";

const ICalendarTemplateDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ICalendarTemplateDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <ICalendarTemplateDetailSection
            iCalendarTemplate={viewModel.iCalendarTemplate}
            availableMergeFieldTopics={viewModel.availableMergeFieldTopics}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <ICalendarTemplateOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            iCalendarTemplateId={viewModel.iCalendarTemplate.iCalendarTemplateId}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
          <ICalendarTemplateActivityPanel
            config={viewModel.activityPanelConfig}
            iCalendarTemplateId={viewModel.iCalendarTemplate.iCalendarTemplateId}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
}

export default ICalendarTemplateDetailApp;